import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import global from './global/index';
import user from './user/index';
import menu from './menu/index';
import wallet from './wallet/index';
import divar from "./divar/index";
import tutorial from "./tutorials/index";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        divar,
        auth,
        htmlClass,
        config,
        breadcrumbs,
        profile,
        global,
        user,
        menu,
        wallet,
        tutorial
    }
});
